import { render, staticRenderFns } from "./VueDataTableIconDialog.vue?vue&type=template&id=6019fdd2&scoped=true"
import script from "./VueDataTableIconDialog.vue?vue&type=script&lang=js"
export * from "./VueDataTableIconDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6019fdd2",
  null
  
)

export default component.exports